/**
 * @flow
 * @relayHash 7c5d3db9ba7d9c32ccd8e0f032fb5779
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CityCreateInput = {|
  name: string,
  zipCode: string,
  countryId: string,
  governorateId: string,
|};
export type CreateCityMutationVariables = {|
  data: CityCreateInput
|};
export type CreateCityMutationResponse = {|
  +createCity: {|
    +id: string
  |}
|};
export type CreateCityMutation = {|
  variables: CreateCityMutationVariables,
  response: CreateCityMutationResponse,
|};
*/


/*
mutation CreateCityMutation(
  $data: CityCreateInput!
) {
  createCity(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "CityCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createCity",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "CityModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateCityMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateCityMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateCityMutation",
    "id": null,
    "text": "mutation CreateCityMutation(\n  $data: CityCreateInput!\n) {\n  createCity(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '65de1e75110e8e82bd1de24e78891196';
module.exports = node;
